import React, {FC, useEffect, useState} from 'react'
import {getSoFood} from '../services'
import {getMasterService} from '../../central/services'
import {MasterModel} from '../../central/model'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
const SoFoodPageWrapper: FC = () => {
  const [status, setStatus] = useState<MasterModel[] | any>([])
  const [code, setCode] = useState<MasterModel[] | any>([])
  const getMasterList = async () => {
    const response = await getMasterService({
      pageNumber: 1,
      size: 100,
      tableName: 'EstadoHttp',
    })
    const data = response.data.data
    const mappedMaster = data.map((master) => ({
      value: master.codigo,
      label: master.nombreCorto,
    }))
    setStatus(mappedMaster)
  }

  const getUrlSoFood = async () => {
    try {
      const response = await getSoFood()
      if (response.data.codigoRespuesta === 200) {
        window.location.href = response.data.Url
      } else {
        setCode(response.data.codigoRespuesta)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getUrlSoFood()
    getMasterList()
  }, [])

  const getMessage =
    Number(code) > 400 && Number(code) < 500
      ? status?.filter((item: {value: any}) => item.value == code)
      : []
  return (
    <>
      <div className='row mt-2 m-0'>
        <div className='col-sm-12 col-lg-4 mt-2 p-0'>
          <div className='card_welcome p-2'>
            {getMessage.length > 0 ? (
              <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Oops! {getMessage[0].label}</h1>
            ) : (
              <h1 className='mb-0'>
                Bienvenidos a <strong>Control de Comensales</strong>{' '}
              </h1>
            )}
          </div>
        </div>
        <div className='col-sm-12 col-lg-6 mt-2 p-0'>
          <div className='welcome_image'>
            <img
              alt='welcome_image'
              src={toAbsoluteUrl('/media/illustrations/central/welcome_comensales.png')}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default SoFoodPageWrapper
